import { createUseStyles } from 'react-jss';
export const useStyles = createUseStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 8,
        width: '100%',
        marginBottom: 8,
        position: 'relative',
    },
    root: {
        marginBottom: 0,
        flex: '1 1 auto',
    },
    titleContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        gap: 12,
        marginBottom: 12,
    },
    itemsContainer: {
        display: 'flex',
        gap: 8,
        flexWrap: 'wrap',
        flexDirection: 'column',
        [theme.breakpoints.up('lg')]: {
            flexDirection: 'row',
        },
    },
    item: {
        display: 'flex',
        gap: 6,
        padding: '12px 16px 12px 8px',
        alignItems: 'stretch',
        backgroundColor: theme.colors.textBackground,
        borderRadius: 12,
        flex: '1 1 auto',
        [theme.breakpoints.up('lg')]: {
            flex: 'inherit',
        },
    },
    itemIconBlock: {
        flexShrink: 0,
        maxHeight: 32,
        paddingTop: 4,
        '& svg': {
            width: 28,
            height: 28,
            '& path': {
                fill: theme.colors.textPrimary,
            },
        },
    },
    itemTitles: {
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
    },
    itemTitle: {
        fontSize: 13,
        overflowWrap: 'break-word',
        wordBreak: 'break-word',
        whiteSpace: 'normal',
        textDecoration: 'none',
        '&[data-type="secondary"]': {
            color: theme.colors.textPrimary,
            fontWeight: 400,
        },
        '&[data-type="main"]': {
            color: theme.colors.sky,
            fontWeight: 700,
            textTransform: 'uppercase',
        },
        '&[data-loading="true"]': {
            width: 170,
            height: 18,
            borderRadius: 6,
            backgroundColor: theme.colors.textTertiary,
        },
    },
    shareIcon: {
        marginRight: '10px',
        '& path': {
            fillOpacity: 1,
        },
    },
}), { name: 'details' });
